import { useEffect, useState } from "react";

type ConfettiAnimationProps = {
    side: "left" | "right"; // Going to control which horn the confetti will come from
};

export default function ConfettiAnimation({ side }: ConfettiAnimationProps) {
    const TOTAL_FRAMES = 75; // Total number of frames in the animation
    const FRAME_RATE = 42; // roughly 24 fps
    const [frameIndex, setFrameIndex] = useState(0); //track the current frame index

    useEffect(() => {
        let frame = 0; // Starting frame

        const interval = setInterval(() => {
            frame++; // Move to the next frame
            if (frame >= TOTAL_FRAMES) {
                // Stop the animation once the last frame is reached
                clearInterval(interval);
            } else {
                setFrameIndex(frame); // Update the state to re-render the next frame
            }
        }, FRAME_RATE);

        return () => clearInterval(interval); // clear interval if the component unmounts
    }, []);

    const FRAME_PATH = `/images/confettiImages/masked${String(frameIndex + 1).padStart(4, "0")}.webp`;

    return (
        <img
            src={FRAME_PATH}
            alt={`Confetti ${frameIndex}`}
            className={`confetti-animation ${side}`}
        />
    );
}
